import { ParamsTypes } from '../analyticsCenter/types';

import {
  RecruitmentsNewsParams,
  RecruitmentsNewsData,
  RecruitmentsKeywordParams,
  RecruitmentsWorkplacesData,
  RecruitmentsCareersData,
  RecruitmentsFormsData,
  RecruitmentsTitlesData,
  RecruitmentsDepartmentsData,
  RecruitmentsVerifyOtpParams,
  RecruitmentsResendOtpParams,
  RecuitmentFaqsType,
  RecuitmentFaqsParams,
  RecruitmentsMembersLoginParamsTypes,
  LoginRecruitmentsMembersData,
  LoginRecruitmentsMembers,
  RecruitmentsNewsDetailData,
  JoinSubmissionsReqTypes,
  PositionListParamTypes,
  RecruitmentPositionTypes,
  RecruitmentsRegisterParams,
  RecruitmentMemberCVRequestTypes,
  RecruitmentMemberCVInfoTypes,
  RecruitmentMemberAvatarRequestTypes,
  ExportRecruitmentMemberCVTypes,
  RecruitmentsSavedJobParams,
  RecruitmentsSavedJobData,
  RecruitmentTypes,
  UploadedType,
  UpdateProfileMemberRecruitmentParams,
  RecruitmentMemberFileRequestTypes,
  RmAppliedJobType,
  RecruitmentForgetPasswordDataTypes,
  RecruitmentChangePasswordDataTypes,
  RecruitmentApplyType,
  RmJoinReasonDetailType,
  RmJoinReasonType,
  RmJoinReasonParams,
  ToggleNewsExpireSoonSubscriptionTypes,
  LikedRecruitmentNewsTypes,
  RecruitmentMemberAvatarTypes,
  RecruitmentsRegisterData,
} from './types';

import axiosInstance from 'services/common/instance';

export const getRecruitmentsNewsService = async (
  params: RecruitmentsNewsParams,
): Promise<PaginationData<RecruitmentsNewsData[]>> => {
  const response = await axiosInstance.get('recruitments/news', { params });
  return response.data;
};

export const getRecruitmentsNewsDetailService = async (
  slug: string,
): Promise<RecruitmentsNewsDetailData> => {
  const response = await axiosInstance.get(`recruitments/news/${slug}`);
  return response.data.data;
};

export const getRecruitmentsWorkplacesService = async (
  params: RecruitmentsKeywordParams,
): Promise<RecruitmentsWorkplacesData[]> => {
  const response = await axiosInstance.get('recruitments/workplaces', {
    params,
  });
  return response.data.data;
};

export const getRecruitmentsCareersService = async (
  params?: RecruitmentsKeywordParams,
): Promise<RecruitmentsCareersData[]> => {
  const response = await axiosInstance.get('recruitments/careers', { params });
  return response.data.data;
};

export const getRecruitmentsFormsService = async (
  params: RecruitmentsKeywordParams,
): Promise<RecruitmentsFormsData[]> => {
  const response = await axiosInstance.get('recruitments/forms', { params });
  return response.data.data;
};

export const getRecruitmentsTitlesService = async (
  params: RecruitmentsKeywordParams,
): Promise<RecruitmentsTitlesData[]> => {
  const response = await axiosInstance.get('recruitments/titles', { params });
  return response.data.data;
};

export const getRecruitmentsDepartmentsService = async (
  params: RecruitmentsKeywordParams,
): Promise<RecruitmentsDepartmentsData[]> => {
  const response = await axiosInstance.get('recruitments/departments', {
    params,
  });
  return response.data.data;
};

export const postRecruitmentsVerifyOtpService = async (
  params: RecruitmentsVerifyOtpParams,
): Promise<void> => {
  const response = await axiosInstance.post(
    'recruitments/members/verify-otp',
    params,
  );
  return response.data.data;
};

export const postRecruitmentsResendOtpService = async (
  params: RecruitmentsResendOtpParams,
): Promise<void> => {
  const response = await axiosInstance.post(
    'recruitments/members/resend-otp',
    params,
  );
  return response.data.data;
};

export const loginRecruitmentsMembersService = async (
  params: RecruitmentsMembersLoginParamsTypes,
): Promise<LoginRecruitmentsMembersData> => {
  const response = await axiosInstance.post(
    'recruitments/members/login',
    params,
  );
  return response.data.data;
};

export const logoutRecruitmentsMembersService = async (): Promise<void> => {
  await axiosInstance.post('recruitments/members/logout');
};

export const getProfileMemberRecruitmentsService = async (): Promise<LoginRecruitmentsMembers> => {
  const response = await axiosInstance.get('recruitments/members/profile');
  return response.data.data;
};

export const getRecuitmentFaqs = async (
  params?: RecuitmentFaqsParams,
): Promise<RecuitmentFaqsType[]> => {
  const response = await axiosInstance.get('recruitments/faqs', { params });
  return response.data.data;
};

export const getRecruitmentsNewsRelatedService = async (
  code: string,
): Promise<PaginationData<RecruitmentsNewsData[]>> => {
  const response = await axiosInstance.get(`recruitments/news/related/${code}`);
  return response.data;
};

export const joinSubmissionService = async (
  formData: JoinSubmissionsReqTypes,
): Promise<void> => {
  const form = new FormData();
  form.append('name', `${formData.name}`);
  form.append('date_of_birth', `${formData.date_of_birth}`);
  form.append('email', formData.email);
  form.append('phone', formData.phone);
  form.append('gender', `${formData.gender}`);
  form.append('hometown', formData.hometown);
  form.append('position_id', `${formData.position_id}`);
  form.append('cv_file', formData.cv_file);
  if (formData.grecaptcha_token) {
    form.append('grecaptcha_token', formData.grecaptcha_token);
  }
  await axiosInstance.post('recruitments/join-submissions', form);
};

export const getRecruitmentPositionService = async (
  params?: PositionListParamTypes,
): Promise<PaginationData<RecruitmentPositionTypes[]>> => {
  const res = await axiosInstance.get('recruitments/positions', { params });
  return res.data;
};

export const getAboutUsPostService = async (
  params?: ParamsTypes,
): Promise<PaginationData<RecruitmentTypes[]>> => {
  const res = await axiosInstance.get('recruitments/about-us-posts', { params });
  return res.data;
};
export const getRecruitmentMemberCvInfoService = async (
): Promise<RecruitmentMemberCVInfoTypes> => {
  const res = await axiosInstance.get('recruitments/members/cv');
  return res.data.data;
};

export const postRecruitmentMemberCvService = async (
  req: RecruitmentMemberCVRequestTypes,
): Promise<void> => {
  const res = await axiosInstance.post('recruitments/members/cv', req);
  return res.data.data;
};

export const postRecruitmentMemberAvatarService = async (
  data: RecruitmentMemberAvatarRequestTypes,
): Promise<void> => {
  const bodyForm = new FormData();
  bodyForm.append('avatar', data.avatar);
  if (data.grecaptcha_token) {
    bodyForm.append('grecaptcha_token', data.grecaptcha_token);
  }
  await axiosInstance.post('recruitments/members/cv', bodyForm);
};

export const postRecruitmentMemberProfileAvatarService = async (
  data: RecruitmentMemberAvatarRequestTypes,
): Promise<RecruitmentMemberAvatarTypes> => {
  const bodyForm = new FormData();
  bodyForm.append('avatar', data.avatar);
  if (data.grecaptcha_token) {
    bodyForm.append('grecaptcha_token', data.grecaptcha_token);
  }
  const res = await axiosInstance.post('recruitments/members/avatar', bodyForm);
  return res.data.data;
};

export const exportRecruitmentMemberCVService = async (
  grecaptchaToken: string,
): Promise<ExportRecruitmentMemberCVTypes> => {
  const res = await axiosInstance.post('recruitments/members/cv/export', {
    grecaptcha_token: grecaptchaToken,
  });
  return res.data.data;
};

export const postRecruitmentsRegisterService = async (
  params: RecruitmentsRegisterParams,
): Promise<RecruitmentsRegisterData> => {
  const response = await axiosInstance.post('recruitments/members/register', params);
  return response.data.data;
};

export const getRecruitmentsSavedJobService = async (
  params: RecruitmentsSavedJobParams,
): Promise<PaginationData<RecruitmentsSavedJobData[]>> => {
  const response = await axiosInstance.get('recruitments/members/all-recruitment-news-liked', { params });
  return response.data;
};

export const getCVUploadedProfileService = async ()
  : Promise<UploadedType> => {
  const response = await axiosInstance.get('recruitments/members/cv/uploaded');
  return response.data.data;
};

export const updateProfileMemberRecruitmentsService = async (
  params: UpdateProfileMemberRecruitmentParams,
): Promise<LoginRecruitmentsMembers> => {
  const response = await axiosInstance.post('recruitments/members/profile', params);
  return response.data.data;
};

export const postRecruitmentMemberProfileFileService = async (
  data: RecruitmentMemberFileRequestTypes,
): Promise<void> => {
  const bodyForm = new FormData();
  bodyForm.append('cv_file', data.cv_file);
  if (data.grecaptcha_token) {
    bodyForm.append('grecaptcha_token', data.grecaptcha_token);
  }
  if (data.cv_data) {
    bodyForm.append('cv_data', JSON.stringify(data.cv_data));
  }
  await axiosInstance.post('recruitments/members/cv/upload', bodyForm);
};

export const getRmAppliedJobService = async (
  params: RecruitmentsSavedJobParams,
): Promise<PaginationData<RmAppliedJobType[]>> => {
  const response = await axiosInstance.get('recruitments/members/applications', { params });
  return response.data;
};

export const postRecruitmentsApplyService = async (
  viaCVOnline: 0 | 1,
  param: RecruitmentApplyType,
): Promise<void> => {
  const bodyForm = new FormData();
  bodyForm.append('news_id', String(param.news_id));
  if (param.grecaptcha_token) {
    bodyForm.append('grecaptcha_token', param.grecaptcha_token);
  }
  const response = await axiosInstance.post(`recruitments/members/apply?via_cv_online=${viaCVOnline}`, bodyForm);
  return response.data.data;
};
export const getRmJoinReasonDetailService = async (
  slug: string,
): Promise<RmJoinReasonDetailType> => {
  const response = await axiosInstance.get(`recruitments/about-us-posts/${slug}`);
  return response.data.data;
};

export const getRmJoinReasonService = async (
  params?: RmJoinReasonParams,
)
  : Promise<PaginationData<RmJoinReasonType[]>> => {
  const response = await axiosInstance.get('recruitments/about-us-posts', { params });
  return response.data;
};
export const toggleNewsExpireSoonSubscriptionService = async (
  req: ToggleNewsExpireSoonSubscriptionTypes,
): Promise<void> => {
  const response = await axiosInstance.post('recruitments/members/toggle-news-expire-soon-subscription', req);
  return response.data.data;
};

export const likeRecruitmentNewsService = async (
  req: LikedRecruitmentNewsTypes,
): Promise<void> => {
  const response = await axiosInstance.post('recruitments/members/like-recruitment-news', req);
  return response.data.data;
};

export default getRecuitmentFaqs;

export const submitForgetPasswordService = async (
  data: RecruitmentForgetPasswordDataTypes,
): Promise<void> => {
  const body = {
    phone_or_email: data.phone_or_email,
    grecaptcha_token: data.grecaptcha_token,
  };
  await axiosInstance.post('recruitments/members/reset-password', body);
};

export const submitChangePasswordService = async (
  data: RecruitmentChangePasswordDataTypes,
): Promise<void> => {
  const body = {
    password: data.password,
    new_password: data.new_password,
    new_password_confirmation: data.new_password_confirmation,
    grecaptcha_token: data.grecaptcha_token,
  };
  await axiosInstance.post('recruitments/members/change-password', body);
};
